module.exports = __webpack_public_path__ + "img/data-availability-006.a5c7ea8b.jpg";